import React, { useEffect, useState } from 'react';
import Home from './Home'
import "../../../Header/home.css"
import Header from '../../../Header';
import MessageLink from '../../../MessageLink';
import Footer from '../../../Footer';
import Banner from '../../../Banner';
import Publicacoes from '../../../Postagens/Publicacoes';
import Noticias from '../../../Postagens/Noticias';
import Lgpd from '../../../Lgpd';
import ErrorBoundary from '../../../ErrorHandler/ErrorBoundary';
import GA4React from 'ga-4-react';

function App() {

  const [isloaded, setLoaded] = useState(false)

  useEffect(() => {

    document.title = "Forluz - Institucional";

    if (!isloaded) {

      setLoaded(true);

      try {

        const ga4react = new GA4React(
          'G-47LVY79GP4',
          { /* ga custom config, optional */ },
          [ /* additional code, optional */],
          3000 /* timeout, optional, defaults is 5000 */,
          /* { nonce: ['first-script-is-async','second-script'] } */
        );
        ga4react.initialize().then((ga4) => {
          console.log("App", decodeURIComponent(document.title));
          ga4.pageview(window.location.pathname + window.location.search, undefined, decodeURIComponent(document.title));
        }, (err) => {
          console.error(err)
        })

      } catch (err) {
        console.error(err);
      }
    }
  }, [isloaded]);

  return (
    <div>

      <ErrorBoundary>
        <Header />
      </ErrorBoundary>

      <ErrorBoundary>
        <Banner />
      </ErrorBoundary>

      <ErrorBoundary>
        <Noticias url={"ObterNoticiasHome"} />
      </ErrorBoundary>

      <ErrorBoundary>
        <Home />
      </ErrorBoundary>

      <ErrorBoundary>
        <Publicacoes url={"ObterPublicacoes"} />
      </ErrorBoundary>

      <ErrorBoundary>
        <Footer />
      </ErrorBoundary>

      <ErrorBoundary>
        <MessageLink />
      </ErrorBoundary>

      <ErrorBoundary>
        <Lgpd />
      </ErrorBoundary>

    </div>
  );
}

export default App;